import React, { useState, useEffect, useCallback } from 'react';
import { supabaseClient } from '../../services/supabase';

// デフォルトのスライド（データベースにデータがない場合のフォールバック）
const defaultSlides = [
  { image_url: '/images/neta.jpg' },
  { image_url: '/images/technique.jpg' },
  { image_url: '/images/don.jpg' }
];

function HeroBanner() {
  const [slides, setSlides] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(-1);
  const [loading, setLoading] = useState(true);

  // データベースからスライドを取得
  useEffect(() => {
    const loadSlides = async () => {
      try {
        const { data, error } = await supabaseClient
          .from('hero_slides')
          .select('*')
          .eq('is_visible', true)
          .order('display_order', { ascending: true });

        if (error) throw error;

        if (data && data.length > 0) {
          setSlides(data);
        } else {
          // データがない場合はデフォルトを使用
          setSlides(defaultSlides);
        }
      } catch (error) {
        console.error('スライド読み込みエラー:', error);
        setSlides(defaultSlides);
      } finally {
        setLoading(false);
      }
    };

    loadSlides();
  }, []);

  const nextSlide = useCallback(() => {
    if (slides.length === 0) return;
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  }, [slides.length]);

  // 初回マウント時に少し遅延してから1枚目をアクティブにする
  useEffect(() => {
    if (loading || slides.length === 0) return;
    
    const initTimer = setTimeout(() => {
      setCurrentSlide(0);
    }, 50);
    return () => clearTimeout(initTimer);
  }, [loading, slides.length]);

  // スライドショーのタイマー
  useEffect(() => {
    if (currentSlide < 0 || slides.length === 0) return;
    
    const timer = setTimeout(nextSlide, 5000);
    return () => clearTimeout(timer);
  }, [currentSlide, nextSlide, slides.length]);

  if (loading) {
    return (
      <section id="hero" className="hero">
        <div className="hero-slider">
          <div className="slide active">
            <div style={{ width: '100%', height: '100%', backgroundColor: '#1a1a1a' }} />
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="hero" className="hero">
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={slide.id || index}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
          >
            <img 
              src={slide.image_url} 
              alt={`スライド ${index + 1}`}
              key={index === currentSlide ? `active-${currentSlide}` : `inactive-${index}`}
              loading={index === 0 ? 'eager' : 'lazy'}
            />
          </div>
        ))}
      </div>
    </section>
  );
}

export default HeroBanner;
